import { useMemo } from "react";
import { useRole } from "@/hooks/auth/useRole";
import { AgentMinimal } from '@/types/agent/agent';
import { useAgentsList } from "./useAgents";

/**
 * Hook for getting agents suitable for filters and select dropdowns
 * - Internal admins: Can see and select all agents
 * - Standard users: Can only see and select active agents (is_active = true)
 */
export const useSelectableAgents = () => {
  const { isInternalAdmin } = useRole();
  const { data: agents, isLoading: agentsLoading, error: agentsError } = useAgentsList();

  const selectableAgents = useMemo(() => {
    if (!isInternalAdmin()) {
      // Admins can select from all agents
      return agents?.filter((agent: AgentMinimal) => agent) || [];
    } else {
      // Standard users can only select from their own active agents
      return agents?.filter((agent: AgentMinimal) => agent.is_active === true) || [];
    }
  }, [agents]);

  return {
    data: selectableAgents,
    isLoading: agentsLoading,
    error: agentsError,
  };
};
